(function () {
  var form = document.getElementById('MaisonCurtainsUseGuarantee');
  if (!form) return;

  var fileInput = form.querySelector('[data-ug-file]');
  var fileBtn = form.querySelector('[data-ug-file-btn]');
  var fileName = form.querySelector('[data-ug-file-name]');
  var photoField = form.querySelector('[data-ug-photo]');
  var bodyField = form.querySelector('[data-ug-body]');

  if (fileBtn && fileInput) {
    fileBtn.addEventListener('click', function () {
      fileInput.click();
    });
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      var name = file ? file.name : '';
      if (fileName) fileName.textContent = name;
      if (photoField) photoField.value = name;
    });
  }

  form.addEventListener('submit', function () {
    var problems = [];
    form.querySelectorAll('[data-ug-problem]:checked').forEach(function (el) {
      problems.push(el.value);
    });
    var order = form.querySelector('#MaisonCurtainsUg-order');
    var name = form.querySelector('#MaisonCurtainsUg-name');
    var notes = form.querySelector('#MaisonCurtainsUg-notes');
    var sizes = form.querySelector('#MaisonCurtainsUg-sizes');
    if (!bodyField) return;
    bodyField.value = [
      'Exact-Fit Guarantee claim.',
      'Order: ' + (order ? order.value : ''),
      'Name: ' + (name ? name.value : ''),
      'Issue: ' + (problems.length ? problems.join(', ') : 'not specified'),
      'Details: ' + (notes ? notes.value : ''),
      'New measurements: ' + (sizes ? sizes.value : ''),
      'Photo: ' + (photoField && photoField.value ? photoField.value : 'not attached')
    ].join('\n');
  });
})();
